import { ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FileService } from 'src/app/services/api/file.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-dialog-add-item-oc',
  templateUrl: './dialog-add-item-oc.component.html',
  styleUrls: ['./dialog-add-item-oc.component.css']
})
export class DialogAddItemOcComponent implements OnInit {
  formItem!: FormGroup;
  temp = 0;
  lstIgv = [18, 10];
  lstInafecto = ['I', 'N'];
  estadoIgv = false;

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<DialogAddItemOcComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private fleService: FileService, private changeDetectorRefs: ChangeDetectorRef,
    private router: Router, public loadingService: LoadingService) {
      this.temp = data.item;
      this.formItem  = this.fb.group({
        item: new FormControl(this.temp, Validators.required),
        descripcion: new FormControl('', Validators.required),
        cantidad: new FormControl(null, Validators.required),
        precioUnidad: new FormControl(null, Validators.required),
        inafecto: new FormControl('I', Validators.required),
        igv: new FormControl(null, Validators.required),
        monto: new FormControl(),
      });
     }

  ngOnInit(): void {
    this.formItem.get("inafecto")?.valueChanges.subscribe((selectedValue: any)  => {
      if(selectedValue === "I"){
        this.estadoIgv = false;
      }else{
        this.estadoIgv = true;
      }
    })
  }

  goBack(){
    if(this.estadoIgv == false){
      this.formItem.controls['igv'].setValue(0);
    }
    if(this.formItem.valid){
      this.dialogRef.close(this.formItem.value);
    }else{
      console.log('uno de los campos no es valido');
    }

  }

  onChange(event: any){
    console.log('eve', event);
  }



}
